'use strict';

var _awsSdk = require('aws-sdk');

var _awsSdk2 = _interopRequireDefault(_awsSdk);

var _emailTemplates = require('./email-templates');

var _emailTemplates2 = _interopRequireDefault(_emailTemplates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDomainSuggestions = function getDomainSuggestions(domain) {
  return new _awsSdk2.default.Route53Domains({ apiVersion: '2014-05-15' }).getDomainSuggestions({ DomainName: domain, OnlyAvailable: true, SuggestionCount: 3 }).promise();
};

var sendNotificationEmail = function sendNotificationEmail(templateName, params) {
  return new _awsSdk2.default.SES({ apiVersion: '2010-12-01' }).sendEmail(_emailTemplates2.default[templateName](params)).promise();
};

module.exports = {
  getDomainSuggestions: getDomainSuggestions,
  sendNotificationEmail: sendNotificationEmail
};